<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="part-1-the-impact-of-trauma">
<h1 style="font-family: Arial; margin-top: 130px;">Part 1<br/> The Impact of Trauma</h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?0e53cdef